// extracted by mini-css-extract-plugin
export default {"narrative":"AwoFh","heading":"fRx1i","textFeild":"iLSvB"};